import axios from "axios";

import { User } from "../types/user";

export const getMe = async (): Promise<User> => {
  return (await axios.get("/api/v1/users/me")).data;
};

export const signIn = async (
  username: string,
  password: string,
): Promise<User> => {
  return (await axios.post("/api/v1/sessions", { username, password })).data;
};

export const signUp = async (
  username: string,
  password: string,
  withoutWorkspace?: boolean,
): Promise<User> => {
  return (
    await axios.post("/api/v1/users", {
      username,
      password,
      "without-workspace": withoutWorkspace,
    })
  ).data;
};

export const resendVerificationEmail = async (
  username: string,
): Promise<void> => {
  await axios.post("/api/v1/verification-emails", { username });
};

export const createPasswordResetToken = async (
  username: string,
): Promise<void> => {
  await axios.post("/api/v1/password-reset-tokens", { username });
};

export const resetPassword = async (
  id: string,
  token: string,
  password: string,
): Promise<void> => {
  await axios.patch(`/api/v1/users/${id}/password`, { token, password });
};
